/**
 *  @class
 *  @function ShopTheLook
 */
if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.closeTimer = null;
      this.onMobileClick = this.onMobileClick.bind(this);
      this.onBackdropClick = this.onBackdropClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
    }

    connectedCallback() {
      this.backdrop = this.querySelector('.thb-hotspot-backdrop');
      this.mobileArea = this.querySelector('.shop-the-look--mobile');
      this.mobileMql = window.matchMedia('(max-width: 767px)');

      this.mobileArea?.addEventListener('click', this.onMobileClick, true);
      this.backdrop?.addEventListener('click', this.onBackdropClick);
      document.addEventListener('keydown', this.onKeydown);
      this.mobileMql.addEventListener('change', this.onMediaChange);
    }

    disconnectedCallback() {
      this.mobileArea?.removeEventListener('click', this.onMobileClick, true);
      this.backdrop?.removeEventListener('click', this.onBackdropClick);
      document.removeEventListener('keydown', this.onKeydown);
      this.mobileMql.removeEventListener('change', this.onMediaChange);
      this.closeModal();
    }

    isMobile() {
      return this.mobileMql.matches;
    }

    onMediaChange() {
      if (!this.isMobile()) {
        this.closeModal(false);
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.classList.contains('is-modal-open')) {
        this.closeModal();
      }
    }

    onBackdropClick() {
      this.closeModal();
    }

    onMobileClick(event) {
      if (!this.isMobile()) {
        return;
      }

      const hotspot = event.target.closest('.thb-hotspot');

      if (!hotspot || !this.mobileArea?.contains(hotspot)) {
        return;
      }

      if (event.target.closest('.thb-hotspot-bubble')) {
        if (event.target.closest('a')) {
          return;
        }
        event.stopPropagation();
        return;
      }

      if (!hotspot.querySelector('.thb-hotspot-bubble')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const wasActive = hotspot.classList.contains('active');

      if (wasActive) {
        this.closeModal();
        return;
      }

      this.closeModal(false);

      hotspot.classList.add('active');
      this.classList.add('is-modal-open');
      document.body.classList.add('shop-the-look-modal-open');
    }

    closeAllHotspots() {
      this.querySelectorAll('.thb-hotspot.active').forEach((hotspot) => {
        hotspot.classList.remove('active');
      });
    }

    closeModal(animate = true) {
      if (this.closeTimer) {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }

      if (!animate) {
        this.closeAllHotspots();
        this.classList.remove('is-modal-open', 'is-modal-closing');
        document.body.classList.remove('shop-the-look-modal-open');
        return;
      }

      if (!this.classList.contains('is-modal-open')) {
        return;
      }

      this.classList.remove('is-modal-open');
      this.classList.add('is-modal-closing');

      this.closeTimer = window.setTimeout(() => {
        this.closeAllHotspots();
        this.classList.remove('is-modal-closing');
        document.body.classList.remove('shop-the-look-modal-open');
        this.closeTimer = null;
      }, 280);
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}
